import adminConfig from "../../admin-config.json";

const ADMIN_PHONE_NUMBERS = new Set(adminConfig.phoneNumbers || []);
const ADMIN_EMAILS = new Set(
  (adminConfig.emails || []).map((email) => email.toLowerCase())
);

export function isAdminUser(user) {
  if (!user) {
    return false;
  }

  const phoneNumber = user.phoneNumber || null;
  const email = user.email?.toLowerCase();

  return (
    ADMIN_PHONE_NUMBERS.has(phoneNumber) ||
    (Boolean(user.emailVerified) && Boolean(email) && ADMIN_EMAILS.has(email))
  );
}
